import React from 'react';
import useTradingHours from '../../../../../hooks/useTradingHours';
import { TRADING_HOURS_CAPTION_COLORS } from '../../../../../constants';
import './styles.css';

const TradingHours = ({ openingHours, spacer }) => {
  const { displayTime } = useTradingHours(openingHours);
  const { tag, nextOpenDay } = displayTime || {};

  if (tag)
    return (
      <div
        style={{
          background:
            TRADING_HOURS_CAPTION_COLORS[tag] ||
            TRADING_HOURS_CAPTION_COLORS.default,
        }}
        className="Listview__Card__trading"
      >
        <i className="icon-generaltime" />
        {tag}
        {nextOpenDay || ''}
      </div>
    );

  if (spacer) return <div className="Listview__Card__spacer" />;
  return '';
};

export default TradingHours;
